<template>
  <div>
    <loading v-show="load"/>
    <div class="container-fluid px-1" v-show="!load">
      <h4 class="font-weight-bold">
        {{ dados && dados.nome_disparo ? dados.nome_disparo : 'Disparo' }}
      </h4>
      <modal-menu :menus="menus" :selected="menu" @changeMenu="toggleMenu"/>
      <div v-if="dados">
        <div v-show="menu === 1">
          <div class="row">
            <div class="col-md-5">
              <div class="row">
                <div class="col-md-12 mb-2">
                  <label class="mb-0" for="mensagem">Nome do disparo*</label>
                  <input type="text" id="titulo" class="form-control" v-model="dados.nome_disparo" maxlength="64" placeholder="Crie um nome para identificar este disparo" required>
                </div>
                <div class="col-md-12 mb-3">
                  <div class="mb-3">
                    <label class="mb-0">Enviar para:</label>
                    <select class="form-control" v-model="dados.tipo_disparo" @change="buscarQtdContatos">
                      <option value="1">Contatos que interagiram nos últimos 30 dias</option>
                      <option value="2">Contatos ausentes (+30 dias sem interagir)</option>
                      <option value="3">Contatos perdidos (+60 dias sem interagir)</option>
                      <option value="4">Contatos que nunca compraram</option>
                      <option value="5">Todos os contatos</option>
                      <option value="6">Clientes LeCard (Site/App)</option>
                      <option value="7">Clientes UaiRango</option>
                      <option value="99">Grupo de contato</option>
                    </select>
                    <div class="mt-2" v-if="dados.tipo_disparo === '99'">
                      <label class="mb-0">Grupo de contato:</label>
                      <select class="form-control" v-model="dados.id_grupo" @change="buscarQtdContatos" required>
                        <option :value="null" disabled>{{ loadContatos ? 'Buscando grupos' : 'Selecione um grupo'}}</option>
                        <option :value="g.id_grupo" v-for="g in grupos">{{g.nome_grupo}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="alert alert-warning small mb-2 d-flex align-items-center" v-if="qtd_contatos > 200">
                    <i class="fa fa-exclamation-triangle mr-2"></i>
                    <div>
                      O envio de mensagens em massa para muitos contatos pode resultar no bloqueio do seu número no WhatsApp.
                      <a href="https://lecard.tawk.help/article/boas-praticas-de-disparo-no-whatsapp" target="_blank" class="text-nowrap">Saiba mais</a>.
                    </div>
                  </div>
                  <div class="alert alert-info mb-0">
                    <div class="small">Público alvo e tempo aproximado:</div>
                    <div v-if="loadContatos">Buscando os contatos..</div>
                    <div v-else>
                      <b>{{ qtd_contatos }} contato{{qtd_contatos !== '1' ? 's' : ''}}</b>
                      <span v-if="qtd_contatos > 0"> | <i class="fa fa-clock small"></i> {{ qtd_contatos * 5 | tempo }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-1">Quando será disparado?</div>
                  <div>
                    <label class="mb-1"><input type="radio" name="schedule" v-model="schedule" value="1" @change="scheduleNotificacao"> Imediatamente</label>
                  </div>
                  <div>
                    <label class="mb-1"><input type="radio" name="schedule" v-model="schedule" value="2" @change="scheduleNotificacao"> Especificar data</label>
                  </div>
                  <div v-if="schedule === '2'">
                    <div class="row no-gutters">
                      <div class="col-6 pr-2"><label class="mb-0">Data</label>
                        <input type="date" :min="today" class="form-control" v-model="dados.disparo" required>
                      </div>
                      <div class="col-6 pr-2"><label class="mb-0">Horário</label>
                        <input type="time" class="form-control" v-model="dados.hora_disparo" required>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7">
              <label class="mb-0" for="mensagem">
                Mensagem* <span class="small ml-2">({{dados.content.length}} de 1024)</span>
              </label>
              <div class="form-msg">
                <textarea id="mensagem" placeholder="Informe a mensagem" required
                          maxlength="1024" style="resize: none" v-model="dados.content"></textarea>
                <div class="btn-action border-top">
                  <button class="btn btn-sm text-secondary bg-white mr-2" @click="menuMsg = 1" :class="{'border-dark': menuMsg === 1}">
                    <i class="fa fa-smile-wink mr-1"></i> Emojis
                  </button>
                  <button class="btn btn-sm text-secondary bg-white mr-2" @click="menuMsg = 2" :class="{'border-dark': menuMsg === 2}">
                    <i class="fa fa-star mr-1"></i> Variáveis
                  </button>
                  <button class="btn btn-sm text-secondary bg-white" @click="menuMsg = 3" :class="{'border-dark': menuMsg === 3}">
                    <i class="fa fa-image mr-1"></i> Imagem <span class="badge badge-primary badge-pill" v-if="dados.url_imagem">1</span>
                  </button>
                </div>
              </div>
              <div class="card p-2" v-show="menuMsg === 1">
                <list-emojis @addEmoji="addEmoji"/>
              </div>
              <div class="card" v-show="menuMsg === 2">
                <div class="card-body px-2">
                  <span class="badge border pointer p-2 mr-2" @click="addEmoji('{nome_cliente}')"><i class="fa fa-plus"></i> <b class="text-info">Nome do cliente</b></span>
                  <span class="badge border pointer p-2" @click="addEmoji('{link}')"><i class="fa fa-plus"></i> <b class="text-info">Link do cardápio</b></span>
                </div>
              </div>
              <div v-show="menuMsg === 3">
                <div class="card card-img">
                  <div class="card-body bg-light mb-0 text-center" style="height: 92px">
                    <img :src="dados.url_imagem" class="rounded" v-if="dados.url_imagem">
                    <div v-else>
                      <i class="fa fa-image fa-2x"></i>
                      <div class="small">Selecione uma imagem</div>
                    </div>
                  </div>
                  <div class="card-body text-center py-3 border-top">
                    <button class="btn btn-dark btn-sm ml-2" @click="removerImagem()" v-if="dados.url_imagem"><i class="fa fa-trash mr-1"></i> Remover</button>
                    <label class="btn btn-info btn-sm mb-0" v-else>
                      <i class="fa fa-plus mr-1"></i> Selecionar
                      <input type="file" class="d-none" accept="image/png,image/jpeg,image/webp" @change="previewImg($event)" >
                    </label>
                  </div>
                </div>
                <div class="small mt-2">
                  Resolução recomendada: <b>512x512</b>. Tamanho máximo <b>512KB</b>. <br>
                  Para reduzir o tamanho da sua imagem: <a href="https://www.iloveimg.com/resize-image" target="_blank">acesse aqui</a>.<br>
                  Para comprimir o tamanho da sua imagem: <a href="https://www.iloveimg.com/compress-image" target="_blank">acesse aqui</a>.<br>
                  Formatos aceitos: <b>PNG, JPG, JPEG e WEBP</b>.
                </div>
              </div>
            </div>
          </div>
          <div v-if="dados.id_notificacao">
            <hr>
            <div class="small mb-3">
              ID: {{dados.id_notificacao}}
            </div>
          </div>
        </div>
        <div class="row" v-show="menu === 2">
          <div class="col-md-6 mb-4 mb-md-0">
            <div class="container-whatspp">
              <div class="wpp-balao">
                <img :src="dados.url_imagem" alt="Img" class="wpp-img" v-if="dados.url_imagem">
                <div class="wpp-balao-body" v-html="preview" v-if="dados.content"></div>
                <div class="wpp-balao-body" v-else>Informe a mensagem</div>
                <div class="balao-hora">{{ dados.hora_disparo || '16:32' }}</div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-2">
            <div>
              <h6 class="mb-0"><b>Data do disparo</b>: {{ dados.ultimo_disparo || 'Não disparado'}}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import ModalMenu from "../../components/commons/ModalMenu";
  import Loading from "../../components/commons/Loading";
  import ListEmojis from "../../components/commons/ListEmojis";

  export default {
    name: 'ModalNotificacao',
    components: {ListEmojis, Loading, ModalMenu},
    props: ['token','cidades'],
    data() {
      return {
        load: false,
        loadContatos: false,
        dados: null,
        semana: [
          {dia: 'Segunda', value: '2'},
          {dia: 'Terça', value: '3'},
          {dia: 'Quarta', value: '4'},
          {dia: 'Quinta', value: '5'},
          {dia: 'Sexta', value: '6'},
          {dia: 'Sábado', value: '7'},
          {dia: 'Domingo', value: '1'}
        ],
        preview: '',
        menu: 1,
        menus: [{ nome: 'Dados', active: true }, { nome: 'Preview', active: true }],
        qtd_contatos: 0,
        grupos: [],

        menuMsg: 1,
        today: '',
        schedule: '1',
        file: null
      }
    },

    methods: {
      salvar(fecharModal) {
        if (!this.dados.content.trim() || !this.dados.nome_disparo) {
          this.$swal('O nome do disparo e a mensagem são obrigatórios');
          return;
        }

        if (this.schedule === '2') {
          if (!this.dados.disparo || !this.dados.hora_disparo) {
            this.$swal('A data e o horário não podem ser vazios');
            return;
          }

          this.dados.data_disparo = `${this.dados.disparo}T${this.dados.hora_disparo}`;

        } else {
          this.dados.data_disparo = null;
        }

        if (this.dados.tipo_disparo === '99' && !this.dados.id_grupo) {
          this.$swal('Por favor selecione um grupo de contatos antes de salvar este disparo.');
          return;
        }

        this.load = true;

        if (this.file) {
          this.salvarImagem(fecharModal);
          return;
        }

        this.$http.post('chatbot/disparos/' + this.token, this.dados)
          .then(response => {
            if (response.data.success) {
              this.load = false;
              this.$swal(`Disparo ${this.dados.id_disparo ? 'atualizado' : 'criado'} com sucesso!`);
              fecharModal(true);
              this.$emit('atualizarDados', this.schedule === '1');

            } else {
              this.load = false;
              this.$swal('Erro ao salvar a notificação!');
            }

        }, res => {
          this.load = false;
          this.$swal(res.data.msg);
        });
      },

      salvarImagem(fecharModal) {
        const data = new FormData();
        data.append('file', this.file);
        data.append('ref_arquivo', 'Disparo');
        data.append('tipo_arquivo', '1');

        this.$http.post('biblioteca/' + this.token, data)
          .then(res => {
            this.loadImg = false;

            if (res.data.success) {
              this.dados.id_arquivo = res.data.id_arquivo;

              this.$http.post('chatbot/disparos/' + this.token, this.dados)
                .then(response => {
                  if (response.data.success) {
                    this.load = false;
                    this.$swal(`Notificação ${this.dados.id_notificacao ? 'atualizada' : 'criada'} com sucesso!`);
                    fecharModal(true);

                  } else {
                    this.load = false;
                    this.$swal('Erro ao salvar a notificação!');
                  }

                }, res => {
                  this.load = false;
                  this.$swal(res.data.msg);
                });
            }

          }, res => {
            console.log(res);
            this.loadImg = false;
            this.$swal("Atenção", res.data.msg);
          });

      },

      buscarQtdContatos() {
        this.qtd_contatos = 0;

        if (this.dados.tipo_disparo === '99') {
          this.buscarGrupos(() => {
            const grupo = this.grupos.find(g => g.id_grupo === this.dados.id_grupo);
            this.qtd_contatos = grupo ? grupo.contatos.length : 0;
          });

          return;

        } else {
          this.dados.id_grupo = null;
        }

        this.loadContatos = true;

        this.$http.get('chatbot/disparos/contatos/' + this.token + '/' + this.dados.tipo_disparo).then(response => {
          this.loadContatos = false;

          if (response.data) {
            this.qtd_contatos = response.data.qtd_contatos || 0;

          } else {
            this.$swal('Erro ao buscar os contatos!');
          }

        }, res => {
          this.loadContatos = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
      },

      buscarGrupos(callback) {
        if (this.grupos.length) {
          callback();
          return;
        }

        this.loadContatos = true;
        this.$http.get('chatbot/grupos/' + this.token)
          .then(response => {
            this.loadContatos = false;
            this.grupos = response.data || [];
            callback();

          }, res => {
            this.loadContatos = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      clear() {
        this.file = null;
        this.schedule = '1';
        this.dados = {
          status: '0',
          id_grupo: null,
          tipo_disparo: '1',
          nome_disparo: '',
          content: '',
          disparo: null,
          data_disparo: null,
          hora_disparo: null,
          dias_reenvio: '1',
          url_imagem: null
        };

        this.buscarQtdContatos();
      },

      scheduleNotificacao() {
        if (this.schedule === '2') {
          const date = new Date();
          this.dados.disparo = this.today;
          this.dados.hora_disparo = `${('0'+date.getHours()).slice(-2)}:${('0'+date.getMinutes()).slice(-2)}`;

        } else {
          this.dados.data_disparo = null;
        }
      },

      addEmoji(emoji) {
        const el = document.getElementById('mensagem');
        let cursorPos = el.selectionEnd;
        this.dados.content = this.dados.content.substring(0, cursorPos) + emoji + this.dados.content.substring(cursorPos);
        cursorPos += emoji.length;
        this.$nextTick(() => {
          el.setSelectionRange(cursorPos, cursorPos);
          el.focus();
        });
      },

      previewImg(e) {
        this.file = null;
        this.dados.url_imagem = null;

        if (e) {
          const img = e.target.files[0];

          if (!img || img.size > 512000) {
            this.$swal({
              text: "O tamanho máximo permitido de uma imagem é de 512kb. Acesse o link abaixo para reduzir o tamanho da sua imagem.",
              buttons: ["Voltar", "Acessar Link"],
              dangerMode: true
            }).then((result) => {
              if (result) {
                window.open('https://www.iloveimg.com/resize-image/resize-png#resize-options,percentage','_blank')
              }
            });

            return;
          }

          this.file = img;
          this.dados.url_imagem = URL.createObjectURL(img);
        }
      },

      removerImagem() {
        this.file = null;
        this.dados.id_arquivo = null;
        this.dados.url_imagem = null;
      },

      toggleMenu(m) {
        this.menu = m;

        if (m === 2) {
          this.preview = this.formatWppMarkdown(this.dados.content);

          if (this.preview) {
            this.preview = this.preview.replaceAll('{nome_cliente}', 'Gustavo');
            this.preview = this.preview.replaceAll('{link}', this.empresa.site);
          }
        }
      },

      formatWppMarkdown(textRef) {
        let format = textRef;
        format = this.whatsappStyles(format, "_", "<i>", "</i>");
        format = this.whatsappStyles(format, "*", "<b>", "</b>");
        return this.whatsappStyles(format, "~", "<s>", "</s>");
      },

      whatsappStyles(format, wildcard, opTag, clTag) {
        let indices = [];

        if (format !== undefined) {
          for (let i = 0; i < format.length; i++) {
            if (format[i] === wildcard) {
              if (indices.length % 2)
                (format[i - 1] === " ") ? null : ((typeof (format[i + 1]) == "undefined") ? indices.push(i) : (this.is_aplhanumeric(format[i + 1]) ? null : indices.push(i)));
              else
                (typeof (format[i + 1]) == "undefined") ? null : ((format[i + 1] === " ") ? null : (typeof (format[i - 1]) == "undefined") ? indices.push(i) : ((this.is_aplhanumeric(format[i - 1])) ? null : indices.push(i)));
            } else {
              (format[i].charCodeAt() === 10 && indices.length % 2) ? indices.pop() : null;
            }
          }
        }

        (indices.length % 2) ? indices.pop() : null;

        let e = 0;
        indices.forEach(function (v, i) {
          let t = (i % 2) ? clTag : opTag;
          v += e;
          format = format.substr(0, v) + t + format.substr(v + 1);
          e += (t.length - 1);
        });

        return format;
      },

      is_aplhanumeric(c) {
        let x = c.charCodeAt(0);
        return ((x >= 65 && x <= 90) || (x >= 97 && x <= 122) || (x >= 48 && x <= 57));
      }
    },

    mounted() {
      const date = new Date();
      this.today = date.toDateInputValue();
    },

    created() {
      this.$parent.$on('salvar', (fecharModal) => {
        this.salvar(fecharModal);
      });

      this.$parent.$on('loadDadosModal', (dados) => {
        this.grupos = [];
        this.menu = 1;

        if (dados && dados.id_disparo) {
          this.load = true;
          this.dados = null;
          this.file = null;

          this.$http.get('chatbot/disparos/' + this.token + '/' + dados.id_disparo).then(response => {
            this.load = false;

            if (response.data && response.data.id_disparo) {
              this.dados = response.data;
              this.buscarQtdContatos();
              this.menuMsg = this.dados.id_arquivo ? 3 : 1;

              if (dados.duplicar) {
                this.dados.id_disparo = null;
                this.dados.data_disparo = null;
                this.dados.status = '0';
                this.schedule = '1';

              } else {
                this.schedule = '2';
              }

            } else {
              this.$swal('Erro ao buscar este disparo!');
            }

          }, res => {
            this.load = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });

        } else {
          this.clear();
          this.$helpers.focusElement('titulo');
        }
      });
    },

    computed: {
      empresa() {
        return this.$store.state.dataUser
      }
    },

    filters: {
      tempo(t) {
        return t > 60 ? `${(t / 60).toFixed()}min` : `${t}s`
      }
    }
  }
</script>

<style scoped>
  .container-whatspp {
    overflow: auto;
    height: calc(100vh - 235px);
    background-color: #EFEAE2;
    padding: 16px 12px 22px;
    position: relative;
  }

  .wpp-balao {
    background-color: #ffffff;
    display: inline-block;
    padding: 6px 7px 8px 9px;
    font-size: 14px;
    border-radius: 8px;
    box-shadow: 0 1px 1px rgba(0,0,0,.13);
    width: 96%;
    max-width: 340px;
    text-align: left;
    position: relative;
  }

  .wpp-balao-body {
    overflow-wrap: break-word;
    white-space: pre-wrap;
  }

  .wpp-img {
    width: 100%;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .balao-hora {
    margin: 5px 2px -3px;
    text-align: right;
    font-size: 12px;
    opacity: 0.7;
  }

  .form-msg {
    margin-bottom: 10px;
    border: 1px solid #dee2e6 !important;
    border-radius: 4px;
    overflow: hidden;
  }

  .form-msg textarea {
    border: 0;
    width: 100%;
    height: 140px;
    padding: 12px;
    outline: none;
    margin: 0!important;
  }

  .form-msg .btn-action {
    padding: 12px;
  }

  .card-img img {
    width: 85px;
    height: 50px;
    object-fit: contain;
    border-radius: 4px;
  }

  @media (max-width: 767px) {
    .container-whatspp {
      height: auto;
    }
  }
</style>
